import { CartItem, invoice, Order } from "@/types/ApiTypes";
import { X } from "lucide-react";
import TableOrdersModalItem from "./TableOrdersModalItem";
import { GoTrash } from "react-icons/go";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { AppConfig } from "@/utils/AppConfig";
import { formatMoney } from "@/utils/helpers";


interface GroupedOrdersModalProps {
    tableData: {
        floor: number;
        table: number;
    }
    toggleOrdersModal: () => void
    orders: Order[]
    setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
    order: invoice
}
export default function GroupedOrdersModal({ toggleOrdersModal, tableData, orders, setRefetch, order }: GroupedOrdersModalProps) {
    const { t } = useTranslation();
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [confirmOrder, setConfirmOrder] = useState<Order | null>(null);

    const contentRef = useRef<HTMLDivElement>(null);
    const toastIdRef = useRef<string | undefined>(undefined);
    const [printLoading, setPrintLoading] = useState(false)
    const [avilableOrders, setAvilableOrders] = useState<Order[]>([]);
    function checkAvilableOrders() {
        const avilableOrders = orders.filter(item => item.status !== "returned" && item.progress !== "cancelled" && item.status !== "cancelled")
        setAvilableOrders(avilableOrders);
    }
    const reactToPrintFn = useReactToPrint({
        contentRef,
        onBeforePrint: async () => {
            setPrintLoading(true);
            return Promise.resolve(); // or simply: return;
        },
        onAfterPrint: () => {
            setPrintLoading(false);
        },
        onPrintError: () => {
            setPrintLoading(false);
        },
    });
    useEffect(() => {
        if (printLoading) {
            // Show loading toast and store the ID
            toastIdRef.current = toast.loading(t("cashierHistoryModal.loading") as string);
        } else {
            if (toastIdRef.current) {
                // Dismiss loading toast
                toast.dismiss(toastIdRef.current);
                toastIdRef.current = undefined;

                // Show success toast
                toast.success(t("cashierHistoryModal.printed") as string);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [printLoading]);
    async function updateStatus(order: Order) {

       
        const toastId = toast.loading(t("cashierHistoryBody.updating") as string);
        try {
            const options = {
                url: `${baseUrl}/api/dashboard/cashier/orders/${order._id}/update`,
                method: "PUT",
                headers: { Authorization: token },
                data: { status: "returned" }
            };
            const response = await axios.request(options);
            if (response.data.success) {
                toast.success(t("cashierHistoryBody.updateSuccess") as string);
                setRefetch(true);
            }
        } catch (error) {
            console.error(error);
        } finally {
            toast.dismiss(toastId);
        }
    }

    useEffect(() => {
        checkAvilableOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orders]);
    return (
        <>
            {order && <>

                <div dir="ltr" ref={contentRef} className="invoice-container text-lg font-semibold  print hidden">
                    <div className="text-center flex items-center flex-col">
                        <div className="w-44 h-auto">
                            <img src={order.logo} alt="Logo" className="w-full h-auto" />
                        </div>

                        <h1 className="text-xl font-bold flex flex-col">
                            <span>{order.restaurantData.nameAR === order.restaurantData.nameEN ? "" : order.restaurantData.nameAR}</span>
                            <span>{order.restaurantData.nameEN}</span>
                        </h1>
                        <h1 className="text-xl font-bold flex flex-col">
                            <span>{order.branch.nameAR === order.branch.nameEN ? "" : order.branch.nameAR}</span>
                            <span>{order.branch.nameEN}</span>
                        </h1>
                        <span className="font-semibold mt-1">{order.branch.address}</span>
                        <span className="font-semibold mt-1">{order.branch.phone}</span>

                        {order.taxNumber && <>
                            <div className="w-full flex  flex-col justify-between my-2 font-semibold">
                                <span>الرقم الضريبي </span>
                                <span>Tax number</span>
                            </div>
                            <div className="flex flex-col items-center gap-2 text-lg">
                                <span className="font-bold">{order.taxNumber}</span>
                            </div></>}

                        <div className="w-full flex flex-col justify-between my-2 font-semibold">
                            <span>فاتورة ضريبية مبسطة</span>
                            <span>Simple tax</span>
                        </div>
                        <span dir="ltr" className="flex border-2  gap-2 border-black p-2 font-bold w-fit text-2xl my-3">
                            Order# <div>{order.orderId}</div>
                        </span>

                        <span dir="ltr" className="font-semibold text-lg flex  gap-1">Unique order ID# <div>{order._id}</div></span>
                        <span className="font-semibold text-md flex gap-1 items-center ">Printed at : <div>{new Date().toLocaleString("en-US")}</div></span>
                        <div className="font-semibold text-md flex items-center gap-1">
                            <span>  Order time : </span>
                            <span >{order.deliverTime}</span>
                            <span> : وقت الطلب  </span>
                        </div>
                    </div>

                    <div className="w-full border-b-2 border-b-black" />


                    <div className="text-center font-semibold">
                        Cashier

                        <div className="flex justify-between text-sm">
                            <div>
                                Floor {tableData.floor || ""} - Table {tableData.table || ""}
                            </div>
                            <div dir="rtl">
                                طابق {tableData.floor || ""} - طاولة {tableData.table || ""}
                            </div>
                        </div>

                    </div>



                    <div className="w-full border-b-2 border-b-black" />

                    <div className=" space-y-1">
                        <div className="flex justify-between font-bold" dir="rtl">
                            <div className="text-start">Price</div>
                            <div className="flex gap-5">
                                <span>item</span>
                                <span>Qty</span>
                            </div>
                        </div>
                        <div className="my-2  w-full border-b-2 border-b-black" />
                        <div className=" font-semibold">
                            {order.items.map((item: CartItem, index) => {
                                return (
                                    <div key={index} className="flex flex-col gap-1">
                                        <div className="flex items-center gap-10  justify-between">
                                            <span className="whitespace-normal flex flex-row-reverse gap-5 " dir="rtl" ><span>{item.quantity} </span>
                                                <span>
                                                    <span className="flex flex-col gap-1">{item.nameEN}</span>
                                                    <span>{item.nameAR === item.nameEN ? "" : item.nameAR}</span>
                                                </span>
                                            </span>
                                            <span dir="ltr" className="flex items-center gap-1 self-start "> {AppConfig.currency.icon()}{formatMoney(item.totalPriceWithTaxes)}</span>
                                        </div>
                                        {item.addons.length > 0 && (
                                            <span className="flex flex-col font-bold">
                                                <span className="text-center">{t("orders.addons")}</span>
                                                <span className="font-normal flex flex-col gap-1 w-full">
                                                    {item.addons.map((addon, i) => {
                                                        const hasPrice = addon.price && addon.price > 0;
                                                        return hasPrice ? (
                                                            <div key={i} className="flex justify-between w-full text-sm">
                                                                <div></div>
                                                                <span className="text-right">{addon.nameEN}|{addon.nameAR}</span>
                                                                <span dir="ltr">
                                                                    {AppConfig.currency.icon()} {formatMoney(addon.price)}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div key={i} className="flex justify-center w-full text-sm">
                                                                <span className="text-right">{addon.nameEN} | {addon.nameAR}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </span>
                                            </span>
                                        )}


                                        {item.options.length > 0 && (
                                            <span className="flex flex-col font-bold">
                                                <span className="text-center">{t("ordersBody.Options")}</span>
                                                <span className="font-normal flex flex-col gap-1 w-full">
                                                    {item.options.map((option, i) =>
                                                        option.options.map((opt, j) => {
                                                            const hasPrice = opt.price && opt.price > 0;
                                                            return hasPrice ? (
                                                                <div key={`${i}-${j}`} className="flex justify-between w-full text-sm">
                                                                    <div></div> {/* Optional for alignment */}
                                                                    <span className="text-right">{opt.nameEN}|{opt.nameAR}</span>
                                                                    {opt.price && opt.price > 0 && (<span dir="ltr">
                                                                        {AppConfig.currency.icon()} {formatMoney(opt.price)}
                                                                    </span>)}
                                                                </div>
                                                            ) : (
                                                                <div key={`${i}-${j}`} className="flex justify-center w-full text-sm">
                                                                    <span className="text-right">{opt.nameEN} | {opt.nameAR}</span>
                                                                </div>
                                                            );
                                                        })
                                                    )}
                                                </span>
                                            </span>
                                        )}
                                        {order.items.length - 1 !== index && <div className="w-full border-b-2 border-b-black" />}
                                    </div>


                                )
                            })}
                        </div>


                    </div>


                    {order.subtotal > 0 && (
                        <>
                            <div className="col-span-full w-full border-b-2 border-b-black" />
                            <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between">
                                <div className="flex flex-col text-end w-[50%]">
                                    <div>Sub total</div>
                                    <div>المجموع الفرعي</div>
                                </div>
                                <div className="text-center">
                                    {AppConfig.currency.icon()} {formatMoney(order.subtotal)}
                                </div>
                            </div>
                        </>
                    )}

                    {order.discount > 0 && (
                        <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between mt-2">
                            <div className="flex flex-col text-end w-[50%]">
                                <div>Discount</div>
                                <div>الخصم</div>
                            </div>
                            <div className="text-center">
                                {AppConfig.currency.icon()} {formatMoney(order.discount)}
                            </div>
                        </div>
                    )}



                    {order.taxes > 0 && (
                        <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between mt-2">
                            <div className="flex flex-col text-end w-[50%]">
                                <div>Taxes (15%)</div>
                                <div>الضرائب (15%)</div>
                            </div>
                            <div className="text-center">
                                {AppConfig.currency.icon()} {formatMoney(order.taxes)}
                            </div>
                        </div>
                    )}
                    <div
                        dir="ltr"
                        className="ml-auto mt-2 flex w-[80%] items-center justify-between font-semibold"
                    >
                        <div className="flex w-[50%] flex-col text-end">
                            <div>Service Fees</div>
                            <div>رسوم الخدمة</div>
                        </div>
                        <div className="text-center">
                            {AppConfig.currency.icon()} {formatMoney(order.serviceFees || 0)}
                        </div>
                    </div>

                    {order.total > 0 && (
                        <>
                            <div className="col-span-full w-full border-b-2 border-b-black mt-2" />
                            <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between mt-2">
                                <div className="flex flex-col text-end w-[50%]">
                                    <div>Total</div>
                                    <div>المجموع</div>
                                </div>
                                <div className="text-center">
                                    {AppConfig.currency.icon()} {formatMoney(order.total)}
                                </div>
                            </div>
                        </>
                    )}

                    {order.cashPaid > 0 && (
                        <>
                            <div className="col-span-full w-full border-b-2 border-b-black mt-2" />
                            <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between mt-2">
                                <div className="flex flex-col text-end w-[50%]">
                                    <div>Total Cash Paid</div>
                                    <div>إجمالي النقد المدفوع</div>
                                </div>
                                <div className="text-center">
                                    {AppConfig.currency.icon()} {formatMoney(order.cashPaid)}
                                </div>
                            </div>
                        </>
                    )}

                    {order.networkPaid > 0 && (
                        <>
                            <div className="col-span-full w-full border-b-2 border-b-black mt-2" />
                            <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between mt-2">
                                <div className="flex flex-col text-end w-[50%]">
                                    <div>Total Credit Paid</div>
                                    <div>إجمالي الشبكة المدفوعة</div>
                                </div>
                                <div className="text-center">
                                    {AppConfig.currency.icon()} {formatMoney(order.networkPaid)}
                                </div>
                            </div>
                        </>
                    )}

                    {order.remainingCash > 0 && (
                        <>
                            <div className="col-span-full w-full border-b-2 border-b-black mt-2" />
                            <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between mt-2">
                                <div className="flex flex-col text-end w-[50%]">
                                    <div>Total Remaining Cash</div>
                                    <div>إجمالي النقد المتبقي</div>
                                </div>
                                <div className="text-center">
                                    {AppConfig.currency.icon()} {formatMoney(order.remainingCash)}
                                </div>
                            </div>
                        </>
                    )}

                    <div className="col-span-full w-full border-b-2 border-b-black mt-2" />

                    <div dir="ltr" className="flex font-semibold w-[80%] ml-auto items-center justify-between mt-2">
                        <div className="flex flex-col text-end w-[50%]">
                            <div>No. Products</div>
                            <div>عدد المنتجات</div>
                        </div>
                        <div className="text-center">{order.totalItems}</div>
                    </div>

                    <div className="col-span-full w-full border-b-2 border-b-black mt-2" />

                    <div dir="ltr" className="flex  font-bold text-sm items-center justify-between w-full ml-auto ">
                        <div className=" text-center">
                            {order.paymentMethod}
                        </div>
                        <div className="flex flex-col  text-end ">
                            <div>Payment method</div>
                            <div>طريقة الدفع</div>
                        </div>
                    </div>

                    <div className="text-center flex items-center justify-center flex-col">
                        <div className="w-52 h-52 ">
                            <img
                                src="https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg"
                                alt="QR"
                                className="w-full h-full object-contain"
                            />
                        </div>
                    </div>
                </div>


            </>}
            {confirmOrder && (
                <div className="fixed inset-0 bg-black/50 z-[99999] flex items-center justify-center">
                    <div className="bg-white p-6 rounded-lg shadow-xl text-center max-w-sm w-full">
                        <h2 className="text-lg font-semibold mb-4">{t("cashierHistoryBody.confirmReturnTitle") || "Confirm Return"}</h2>
                        <p className="mb-6">
                            {t("cashierHistoryBody.confirmReturnMessage")}
                        </p>
                        <div className="flex justify-center gap-4">
                            <button
                                onClick={() => {
                                    updateStatus(confirmOrder);
                                    setConfirmOrder(null);
                                }}
                                className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
                            >
                                {t("buttons.confirm")}
                            </button>
                            <button
                                onClick={() => setConfirmOrder(null)}
                                className="bg-gray-300 text-gray-800 px-4 py-2 rounded hover:bg-gray-400 transition"
                            >
                                {t("buttons.cancel")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div onClick={toggleOrdersModal} className="fixed inset-0 bg-black bg-opacity-30 z-[9999] flex items-center justify-center">
                <div onClick={(e) => e.stopPropagation()} className="bg-white relative flex flex-col gap-2 rounded-lg max-h-[92vh]  p-2 min-w-[90%] md:min-w-[50%]">
                    <X className="absolute top-2 end-2 text-red-600 cursor-pointer " size={24} onClick={toggleOrdersModal} />
                    <h1 className="text-lg text-center bg-gray-600 text-skyblue font-semibold p-2 w-fit rounded-lg mx-auto"> {t("manageTables.floor")} {tableData.floor} - {t("manageTables.table")} {tableData.table}</h1>
                    <div className="space-y-2 overflow-auto">
                        {avilableOrders.length > 0 ?
                            avilableOrders.map((item, i) => (

                                <div key={i} className="border border-gray-300  rounded-lg overflow-hidden">
                                    <div className="bg-skyblue text-sidebar font-semibold p-2 text-center flex items-center justify-between">
                                        <span>  {t("manageTables.orderNumber")}  #{item.orderId}</span>
                                        <div className="flex items-center gap-5 ">
                                            <span
                                                className={`w-fit text-start px-2 py-1 text-xs rounded-full ${item.status === "pending"
                                                    ? "bg-yellow-500 text-white"
                                                    : item.progress === "finished"
                                                        ? "bg-green-300 text-green-900"
                                                        : item.progress === "preparing"
                                                            ? "bg-blue-600 text-white"
                                                            : item.progress === "delivering"
                                                                ? "bg-orange-500 text-white"
                                                                : item.progress === "delivered"
                                                                    ? "bg-green-700 text-white"
                                                                    : item.status === "accepted"
                                                                        ? "bg-sidebar text-skyblue"

                                                                        : item.status === "returned"
                                                                            ? "bg-red-600 text-white"
                                                                            : "bg-red-600 text-white"
                                                    }`}
                                            >
                                                {item.status === "pending"
                                                    ? t("clientTableStatus.pending")
                                                    : item.progress === "finished"
                                                        ? t("clientTableStatus.finished")
                                                        : item.progress === "preparing"
                                                            ? t("clientTableStatus.preparing")
                                                            : item.progress === "delivering"
                                                                ? t("clientTableStatus.delivering")
                                                                : item.progress === "delivered"
                                                                    ? t("clientTableStatus.received")
                                                                    : item.status === "accepted"
                                                                        ? t("clientTableStatus.accepted")

                                                                        : item.status === "returned"
                                                                            ? t("clientTableStatus.returned")
                                                                            : item.status === "rejected"
                                                                                ? t("clientTableStatus.rejected")
                                                                                : t("clientTableStatus.cancelled")}
                                            </span>

                                            <button onClick={() => setConfirmOrder(item)} className="text-red-500">
                                                <GoTrash size={20} className="text-red-400 hover:text-red-600" />
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        {(item.status !== "returned" && item.progress !== "cancelled" && item.status !== "cancelled") && (
                                            item.items.map((orderItem, i) => (
                                                <TableOrdersModalItem
                                                    key={i}
                                                    item={orderItem}
                                                    length={item.items.length}
                                                    index={i}
                                                />
                                            ))
                                        )}

                                    </div>

                                </div>
                            )) :
                            <div className="flex items-center justify-center py-5 h-full bg-skyblue rounded-md">
                                <p className="font-semibold text-sidebar">{t("cashierHistoryBody.noOrders")}</p>
                            </div>
                        }
                    </div>
                    <div className="flex items-center justify-end gap-4 mt-3">
                        <button disabled={avilableOrders.length === 0} onClick={() => reactToPrintFn()} className="my-btn w-fit px-4 py-2 disabled:bg-gray-400 disabled:cursor-not-allowed">{t("cashierHistoryModal.print")}</button>
                        <button onClick={toggleOrdersModal} className="bg-red-600 text-white px-4 my-btn w-fit rounded hover:bg-red-700 transition"
                        >{t("buttons.cancel")}</button>
                    </div>
                </div>
            </div>
        </>
    )
}
